import {Line} from "react-konva";
import type Konva from "konva";
import {useDungeon} from "@/encounter/dungeon/DungeonHooks.ts";
import {useDoorStates} from "@/encounter/doors/DoorStateHooks.ts";
import {gridToWorld} from "@/dungeons/geometry/Coordinates.ts";
import {useEncounterViewPort} from "@/encounter/viewport/EncounterViewPortHooks.ts";
import type {Door} from "@/dungeons/model/DungeonGeometry.ts";
import {useTableTopSelection} from "@/tabletop/selection/TableTopSelectionHooks.ts";

export default function DungeonDoorLayer({onSelectDoor}: {onSelectDoor: (door: Door) => void}) {
    const {dungeon, dungeonSettings} = useDungeon();
    const {stateFor} = useDoorStates();
    const {clearSelection} = useTableTopSelection();
    const {mapTransform} = useEncounterViewPort();
    const level = dungeon.levels.find(candidate => candidate.id === dungeonSettings.levelId);
    if (!level) return null;

    const select = (event: Konva.KonvaEventObject<MouseEvent | TouchEvent>, door: Door) => {
        event.cancelBubble = true;
        clearSelection();
        onSelectDoor(door);
    };

    return <>
        {level.geometry.doors.map(door => {
            const start = gridToWorld(door.start, level.geometry.grid);
            const end = gridToWorld(door.end, level.geometry.grid);
            const state = stateFor(door);
            return <Line
                key={door.id}
                points={[start.x, start.y, end.x, end.y]}
                stroke={door.secret ? "#c084fc" : state === "OPEN" ? "#10b981" : "#f59e0b"}
                strokeWidth={5 / mapTransform.scale}
                hitStrokeWidth={18 / mapTransform.scale}
                dash={state === "OPEN" ? [8 / mapTransform.scale, 8 / mapTransform.scale] : undefined}
                lineCap="round"
                onClick={event => select(event, door)}
                onTap={event => select(event, door)}
            />;
        })}
    </>;
}
